export const VALID_RANKS = ['E5', 'E6'];
export const FIXED_DUTY_STATE = 'Regular';
export const getRatingExamNumber = (rank) => {
  switch (rank) {
    case 'E5':
      return '2';
    case 'E6':
      return '1';
    default:
      return '';
  }
};
